import { Checkbox, Col, Form, FormInstance, Input, Radio } from 'antd'

import { requiredRules } from 'src/app-constants'
import { useLocales } from 'src/locales'

type Props = {
  form: FormInstance
}

export const OtherSymptomsCard = ({ form }: Props) => {
  const { t } = useLocales()

  const hasOther =
    Form.useWatch(['form', 'symptoms', 'other', 'status'], form) === 'yes'

  const hasLymphNodeSwelling = Form.useWatch(
    ['form', 'symptoms', 'other', 'lymphNodeSwelling', 'isSelected'],
    form
  )

  const hasOtherOther = Form.useWatch(
    ['form', 'symptoms', 'other', 'other', 'isSelected'],
    form
  )

  return (
    <>
      <Col span={24}>
        <Form.Item
          name={['form', 'symptoms', 'other', 'status']}
          rules={requiredRules}
          label={`9. ${t('epidemiology.other')}`}
        >
          <Radio.Group>
            <Radio value="dontKnow">{t('epidemiology.unknown')}</Radio>
            <Radio value="no">{t('common.no')}</Radio>
            <Radio value="yes">{t('common.yes')}</Radio>
          </Radio.Group>
        </Form.Item>
      </Col>

      {hasOther && (
        <>
          <Col span={8}>
            <Form.Item
              name={[
                'form',
                'symptoms',
                'other',
                'lymphNodeSwelling',
                'isSelected'
              ]}
              valuePropName="checked"
            >
              <Checkbox>1. Tumefierea ganglionilor limfatici</Checkbox>
            </Form.Item>
          </Col>

          {hasLymphNodeSwelling && (
            <>
              <Col span={8}>
                <Form.Item
                  name={[
                    'form',
                    'symptoms',
                    'other',
                    'lymphNodeSwelling',
                    'occipitalLymphNodes',
                    'isSelected'
                  ]}
                  valuePropName="checked"
                >
                  <Checkbox>1.1 Ganglioni occipitali</Checkbox>
                </Form.Item>
              </Col>

              <Col span={8}>
                <Form.Item
                  name={[
                    'form',
                    'symptoms',
                    'other',
                    'lymphNodeSwelling',
                    'submandibularLymphNodes',
                    'isSelected'
                  ]}
                  valuePropName="checked"
                >
                  <Checkbox>1.2 Ganglioni submandibulari</Checkbox>
                </Form.Item>
              </Col>

              <Col span={8}>
                <Form.Item
                  name={[
                    'form',
                    'symptoms',
                    'other',
                    'lymphNodeSwelling',
                    'axillaryLymphNodes',
                    'isSelected'
                  ]}
                  valuePropName="checked"
                >
                  <Checkbox>1.3 Ganglioni axilari</Checkbox>
                </Form.Item>
              </Col>
            </>
          )}
          <Col span={8}>
            <Form.Item
              name={[
                'form',
                'symptoms',
                'other',
                'salivaryGlandSwelling',
                'isSelected'
              ]}
              valuePropName="checked"
            >
              <Checkbox>2. Tumefierea glandelor salivare</Checkbox>
            </Form.Item>
          </Col>

          <Col span={8}>
            <Form.Item
              name={['form', 'symptoms', 'other', 'other', 'isSelected']}
              valuePropName="checked"
            >
              <Checkbox>3. Altele (specificați)</Checkbox>
            </Form.Item>
          </Col>

          {hasOtherOther && (
            <Col span={8}>
              <Form.Item
                name={[
                  'form',
                  'symptoms',
                  'other',
                  'other',
                  'specify',
                  'value'
                ]}
              >
                <Input placeholder="Specificați" />
              </Form.Item>
            </Col>
          )}
        </>
      )}
    </>
  )
}
